import React from "react";

import CloseIcon from "@uui/XClose";

import PlanChip from "@app/analytics/components/PlanChip";
import Config from "@app/config";

import Alert from "@rui/Alert";
import IconButton from "@rui/IconButton";

const FreeTrialUpsellBanner = ({
  children,
  onDismiss,
}: {
  children: React.ReactNode;
  onDismiss: () => void;
}) => (
  <Alert
    severity="info"
    sx={{ borderRadius: 0, p: 1.5 }}
    icon={
      <PlanChip
        label="Premium"
        sx={{ bgcolor: "transparent !important", fontSize: "0.675rem" }}
      />
    }
    action={
      <IconButton onClick={onDismiss} size="small">
        <CloseIcon sx={{ fontSize: "18px" }} />
      </IconButton>
    }
  >
    <span style={{ fontWeight: 500 }}>Free preview with trial:</span> {children}{" "}
    Enjoy a free preview of this feature with your {Config.billing.trialDays}
    -day trial!
  </Alert>
);

export default FreeTrialUpsellBanner;
